import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {FeatureEvidVidCreateInfo} from '@catmodules/models/feature-evid-vid/types';
import {Restangular} from 'ngx-restangular';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class FeatureEvidVidService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('feature-evid-vids', service);
  }

  create(item: FeatureEvidVidCreateInfo): Observable<any> {
    return this.queryAll()
      .post({
        evid_function_type: item.evidFunction._links.self.href,
        model: item.evidVid._links.self.href,
        evid_type: item.evid._links.self.href,
        name: item.name,
        values_string: item.valuesString,
        default_value: item.defaultValue,
      })
      .map((createdItem) => {
        // this.store.dispatch({
        //     type: storeActions.CORE_FEATURE_CREATED,
        //     payload: createdFeature,
        //   },
        // );
        return createdItem;
      });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/feature-evid-vid/services/feature-evid-vid.service.ts